import { useEffect, useState } from 'react';
import { useLeadSubmit } from './useLeadSubmit';

const EMPTY = { name: '', email: '', phone: '', area: 'both', smsConsent: false };

// Form state + submission for the Relocation Guide modal. Syncs `area` from the
// parent only when the modal (re)opens so a manual pick inside isn't overridden.
export const useRelocationForm = ({ open, initialArea, onClose }) => {
  const [form, setForm] = useState({ ...EMPTY, area: initialArea || 'both' });
  const update = (patch) => setForm((prev) => ({ ...prev, ...patch }));
  const { submitted, submitting, submit } = useLeadSubmit({
    endpoint: '/leads/guide-download',
    errorLabel: 'relocation guide lead',
    onSuccess: () => { onClose(); setForm(EMPTY); },
  });

  useEffect(() => {
    if (open && initialArea) {
      setForm((prev) => (prev.area === initialArea ? prev : { ...prev, area: initialArea }));
    }
  }, [open, initialArea]);

  const handleSubmit = (e) => {
    e.preventDefault();
    submit({ name: form.name, phone: form.phone, email: form.email, guide_type: `2026_coastal_relocation_${form.area}`, sms_consent: form.smsConsent });
  };

  return { form, update, submitted, submitting, handleSubmit };
};
